/**
 * 安全配置
 */
import { Component, useState, useEffect } from 'react';
import $ from 'jquery';
import cookie from 'react-cookies';
import {
    Row,
    Col,
    Steps,
    Button,
    Input,
    Progress,
    Tag,
} from 'antd';
import CNF from '../../incs/Config.js';
import {
    CheckOutlined,
    CheckCircleOutlined,
    SolutionOutlined,
    EditOutlined
} from '@ant-design/icons';
import { AddRequestHeaders, DeleteCookies } from '../../incs/FunHelper.js';

const themeColor = cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0];

/**
 * 第一步
 * 密码验证
 */
class PasswordS1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            res: 1,
            msg: '*',
            loading: false
        }
    }

    changPassword = (e) => {
        this.setState({
            password: e.target.value,
            loading: false
        });
    }

    verifyPassword() {
        this.setState({ loading: true });

        if (this.state.password === '') {
            this.setState({
                msg: '密码不能为空！'
            });
            return;
        }
        const _this = this;
        $.ajax({
            url: CNF.api + 'users/oauth/verification',
            type: 'GET',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: {
                'method': 'password',
                'password': this.state.password,
            },
            success: function (data) {
                _this.setState({
                    res: data.res,
                    msg: data.msg
                });
                if (data.res === 0) {
                    _this.props.changeVerifyFingerprint(data.dat);
                    _this.props.changeStatus(2);
                }
            }
        })
    }

    render() {
        return (
            <div>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>密码验证账户 <span style={{ color: themeColor }}>{this.props.username}</span>, 为确保是您本人操作, 请完成以下验证：</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.password}
                            onChange={this.changPassword}
                            type={'password'}
                            placeholder='请输入登录密码'
                            style={{ borderRadius: '0' }}
                        />
                    </Col>
                    <Col span={4}><span style={{ marginLeft: '10px', lineHeight: '30px', color: this.state.res > 0 ? 'red' : 'green' }}>
                        {this.state.msg}
                    </span>
                    </Col>
                </Row>
                <Row style={{ marginTop: '0px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            variant='solid'
                            style={{ borderRadius: 0, border: 0, marginTop: '25px' }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.verifyPassword();
                            }}>马上验证
                        </Button>
                    </Col>
                </Row>
            </div>
        )
    }
}

/**
 * 第一步
 * 手机验证
 */
class PhoneS1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vCode: '',
            msg: '',
            vMsg: '',
            isGainVCode: 0,
            vTime: 0,
            bTitle: '获取验证码',
            verifyId: '',
            loading: false
        }
    }

    changVCode = (e) => {
        this.setState({
            vCode: e.target.value,
            msg: '',
            loading: false
        });
    }

    changeVTime = (t) => { this.setState({ vTime: t }); }


    sendVCode() {
        this.setState({ vTime: 60 });
        const _this = this;
        $.ajax({
            url: CNF.api + 'users/sendVerifyCode',
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON',
            data: {
                'method': 'phone',
                'phone': this.props.phone
            }, success: function (data) {
                if (data.res === 0) {
                    _this.setState({
                        isGainVCode: 1,
                        verifyId: data.dat
                    });
                } else {
                    _this.setState({ vMsg: data.msg });
                }
            }
        })
    }

    /***
     * 通过验证码验证身份
     */
    verifyVCode() {
        this.setState({ loading: true });
        if (this.state.vCode === '') {
            this.setState({
                msg: '验证码不能为空！'
            });
            return;
        }
        const _this = this
        $.ajax({
            url: CNF.api + 'users/verifyVerifyCode',
            type: 'GET',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: {
                'verify_id': this.state.verifyId,
                'verify_code': this.state.vCode
            }, success: function (data) {
                _this.setState({
                    res: data.res,
                    msg: data.msg
                });
                if (data.res === 0) {
                    _this.props.changeVerifyFingerprint(data.dat);
                    _this.props.changeStatus(2);
                }
            }
        })
    }

    render() {
        return (
            <div>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>手机验证账户 <span style={{ color: themeColor }}>{this.props.username}</span> 为确保是您本人操作, 请完成以下验证：</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>手机号码：</label>
                    </Col>
                    <Col span={3}>
                        <label>{this.props.phone}</label>
                    </Col>
                    <Col span={4}></Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>验证码：</label>
                    </Col>
                    <Col span={2}>
                        <Input
                            value={this.state.vCode}
                            onChange={this.changVCode}
                            placeholder='请输入验证码'
                            style={{ borderRadius: '0', width: '110px' }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.vTime > 0 ? true : false}
                            onClick={() => {
                                this.sendVCode();
                            }}><BTitle vTime={this.state.vTime} changeVTime={this.changeVTime} />
                        </Button>
                    </Col>
                    <Col span={4}><span style={{ color: 'red', marginLeft: '10px' }}>{this.state.vMsg}</span></Col>
                </Row>
                <Row>
                    <Col span={this.state.isGainVCode < 1 ? 0 : 12} offset={7}>
                        <label style={{ fontSize: '12px', color: '#B2B2B2' }}>
                            <CheckCircleOutlined /> 验证码已发送到您的手机, 15分钟内输入有效, 验证码等同于密码, 打死也不能告诉别人哦！
                        </label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '25px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.verifyVCode();
                            }}>马上验证
                        </Button>
                    </Col>
                    <Col span={4}><span style={{ color: 'red', marginLeft: '10px', lineHeight: '30px' }}>{this.state.msg}</span></Col>
                </Row>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={18} offset={5} style={{ fontSize: '12px' }}>
                        <p style={{ fontSize: '16px', fontWeight: 'bold' }}>没收到短信验证码？</p>
                        <p>1、网络通讯异常可能会造成短信丢失, 请重新获取或稍后再试。</p>
                        <p>2、请核实手机是否已欠费停机, 或者屏蔽了系统短信。</p>
                        <p>3、如果手机已丢失或停用,  请选择其他验证方式 。</p>
                        <p>4、您也可以尝试将SIM卡移动到另一部手机, 然后重试。</p>
                    </Col>
                </Row>
            </div>
        )
    }
}

/**
 * 第一步
 * 邮箱验证
 */
class EmailS1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vCode: '',
            msg: '',
            vMsg: '',
            isGainVCode: 0,
            vTime: 0,
            bTitle: '获取验证码',
            verifyId: '',
            loading: false
        }
    }

    changVCode = (e) => {
        this.setState({
            vCode: e.target.value,
            msg: '',
            loading: false
        });
    }

    changeVTime = (t) => { this.setState({ vTime: t }); }

    /**
     * 发送验证码
     */
    sendVCode() {
        this.setState({ vTime: 60 });
        const _this = this;
        $.ajax({
            url: CNF.api + 'users/sendVerifyCode',
            type: 'GET',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: {
                'method': 'email',
                'email': this.props.email
            }, success: function (data) {
                if (data.res === 0) {
                    _this.setState({
                        isGainVCode: 1,
                        verifyId: data.dat
                    });
                } else {
                    _this.setState({ vMsg: data.msg });
                }
            }
        })
    }

    /***
     * 通过验证码验证身份
     */
    verifyVCode() {
        this.setState({ loading: true });
        if (this.state.vCode === '') {
            this.setState({
                msg: '验证码不能为空！'
            });
            return;
        }
        const _this = this
        $.ajax({
            url: CNF.api + 'users/verifyVerifyCode',
            type: 'GET',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: {
                'verify_id': this.state.verifyId,
                'verify_code': this.state.vCode
            }, success: function (data) {
                _this.setState({
                    res: data.res,
                    msg: data.msg
                });
                if (data.res === 0) {
                    _this.props.changeVerifyFingerprint(data.dat);
                    _this.props.changeStatus(2);
                }
            }
        })
    }

    render() {
        return (
            <div>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>邮箱验证账户 <span style={{ color: themeColor }}>{this.props.username}</span> 为确保是您本人操作, 请完成以下验证：</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>邮箱：</label>
                    </Col>
                    <Col span={3}>
                        <label>{this.props.email}</label>
                    </Col>
                    <Col span={4}></Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>验证码：</label>
                    </Col>
                    <Col span={2}>
                        <Input
                            value={this.state.vCode}
                            onChange={this.changVCode}
                            placeholder='请输入验证码'
                            style={{ borderRadius: '0', width: '110px' }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.vTime > 0 ? true : false}
                            onClick={() => {
                                this.sendVCode();
                            }}><BTitle vTime={this.state.vTime} changeVTime={this.changeVTime} />
                        </Button>
                    </Col>
                    <Col span={4}><span style={{ color: 'red', marginLeft: '10px' }}>{this.state.vMsg}</span></Col>
                </Row>
                <Row>
                    <Col span={this.state.isGainVCode < 1 ? 0 : 12} offset={7}>
                        <label style={{ fontSize: '12px', color: '#B2B2B2' }}>
                            <CheckCircleOutlined /> 验证码已发送到您的邮箱, 15分钟内输入有效, 验证码等同于密码, 打死也不能告诉别人哦！
                        </label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '25px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.verifyVCode();
                            }}>马上验证
                        </Button>
                    </Col>
                    <Col span={4}><span style={{ color: 'red', marginLeft: '10px', lineHeight: '30px' }}>{this.state.msg}</span></Col>
                </Row>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={18} offset={5} style={{ fontSize: '12px' }}>
                        <p style={{ fontSize: '16px', fontWeight: 'bold' }}>没收到邮件验证码？</p>
                        <p>1、网络异常可能会造成邮件丢失, 请重新获取或稍后再试。</p>
                        <p>2、检查邮件收信规则设置, 检查收信条件是否设置不当。</p>
                        <p>3、检查反垃圾设置, 黑名单中是否误加入了正常邮箱地址 。</p>
                        <p>4、或者在垃圾邮件中查找看看。</p>
                    </Col>
                </Row>
            </div>
        )
    }
}

/***
 * 控制获取验证码按钮文字显示
 */
class BTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '获取验证码'
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const _this = this;
        if (nextProps.vTime > 0) {
            setTimeout(function () {
                _this.props.changeVTime(nextProps.vTime - 1);
            }, 1000);
            _this.setState({ title: nextProps.vTime - 1 + 's 后, 可重新获取验证码' });
        }
        if (nextProps.vTime < 1) {
            _this.setState({ title: '获取验证码' });
        }
    }

    render() {
        return (
            <span>{this.state.title}</span>
        )
    }
}

/**
 * 第二步
 * 修改密码
 */
class PasswordS2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            vPassword: '',
            msg: '',
            loading: false,
            pStrength: 0,
            c1: '#BFBFBF',
            c2: '#BFBFBF',
            c3: '#BFBFBF'
        }
    }

    getPasswordType(value) {
        var s = 0;
        // 是否包含数字
        if (/([0-9])/.exec(value)) {
            s += 1;
        }
        //  是否包含小写字母
        if (/([a-z])/.exec(value)) {
            s += 1;
        }
        //  是否包含大写字母
        if (/([A-Z])/.exec(value)) {
            s += 1;
        }
        //  是否包含标点符号
        if (/([^0-9a-zA-Z])/.exec(value)) {
            s += 1;
        }
        return s;
    }

    verifyPasswordStrength(value) {
        /***
         * 验证密码强度
         * 1、密码必须在 6~20 个字符之间
         * 2、只能包含大小写字母、数字、下滑线及标点符号（空格除外）
         * 3、大写字母、小写字母、数字及标点符号至少包含 2 种及以上
         * 
         * 密码强弱判断
         * 通过权重判断
         * 1、长度 < 8 w += 1
         * 2、长度 >= 8 w += 2
         * 3、2 种类型 w += 1
         * 4、3 种类型 w += 2
         * 5、4 种类型 w += 3
         * 6 w <= 2 pStrength=1
         * 7 w > 2 && w <=4 pStrength=2
         * 8 w > 4 pStrength=3
         */

        var w = 0;
        if (value.length >= 8) {
            w += 1;
        }

        var s = this.getPasswordType(value);
        if (s < 2) {
            w += 1;
        } else if (s > 3) {
            w += 3;
        } else {
            w += 2;
        }

        var pStrength = 1;
        if (w > 3) {
            pStrength = 3;
        } else if (w > 1 && w < 4) {
            pStrength = 2;
        }

        this.setState({ pStrength: pStrength });
    }

    changPassword = (e) => {
        this.setState({
            loading: false,
            msg: '',
            password: e.target.value.replace(' ', '')
        });
        if (e.target.value.replace(' ', '').length >= 6) {
            this.verifyPasswordStrength(e.target.value.replace(' ', ''));
        }
    }

    changVPassword = (e) => {
        this.setState({
            loading: false,
            msq: '',
            vPassword: e.target.value
        });
    }

    updatePassword() {
        this.setState({ loading: true });

        if (this.state.password.length < 6
            || this.state.password.length > 20
            || this.getPasswordType(this.state.password) < 2
            || /([\u4e00-\u9fa5])/.exec(this.state.password)) {
            this.setState({
                msg: '密码格式错误！'
            });
            return;
        }

        if (this.state.password !== this.state.vPassword) {
            this.setState({
                msg: '两次输入密码不一致！'
            });
            return;
        }

        const _this = this;

        $.ajax({
            url: CNF.api + 'users/securityinfo',
            type: 'PATCH',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: JSON.stringify({
                'type': 'password',
                'verify_fingerprint': this.props.verifyFingerprint,
                'password': this.state.password
            }), success: function (data) {
                _this.setState({
                    res: data.res,
                    msg: data.msg
                });
                if (data.res === 0) {
                    _this.props.changeStatus(3);
                } else {
                    _this.setState({ loading: false });
                }
            }
        })
    }

    componentDidUpdate() {
        var c1 = '#BFBFBF';
        var c2 = '#BFBFBF';
        var c3 = '#BFBFBF';
        switch (this.state.pStrength) {
            case 1:
                c1 = 'red';
                break;
            case 2:
                c1 = '#EF6730';
                c2 = '#EF6730';
                break;
            case 3:
                c1 = 'green';
                c2 = 'green';
                c3 = 'green';
                break;
            default:
                break;
        }
        if (this.state.c1 !== c1 || this.state.c2 !== c2 || this.state.c3 !== c3) {
            this.setState({
                c1: c1,
                c2: c2,
                c3: c3
            });
        }
    }

    render() {
        return (
            <>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>修改账户 <span style={{ color: themeColor }}>{this.props.username}</span> 密码, 请完成修改。</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px', fontSize: '12px' }}>
                    <Col span={14} offset={5}>
                        <p>1、密码必须在 6~20 个字符之间</p>
                        <p>2、只能包含大小写字母、数字、下滑线及标点符号（空格除外）</p>
                        <p>3、大写字母、小写字母、数字及标点符号至少包含 2 种及以上</p>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.password}
                            onChange={this.changPassword}
                            type={'password'}
                            placeholder='请输入新密码...'
                            style={{ borderRadius: '0' }}
                        />
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}>
                        {
                            this.state.password === '' ? (<span>*</span>) : (
                                <div>
                                    <Progress strokeColor={this.state.c1} style={{ float: 'left', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                    <Progress strokeColor={this.state.c2} style={{ float: 'left', marginLeft: '5px', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                    <Progress strokeColor={this.state.c3} style={{ float: 'left', marginLeft: '5px', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                </div>
                            )
                        }
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.vPassword}
                            onChange={this.changVPassword}
                            type={'password'}
                            placeholder='请再次输入新密码...'
                            style={{ borderRadius: '0' }}
                        />
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}><span>*</span></Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: '0', border: '0' }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.updatePassword();
                            }}>马上修改</Button>
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}><span>{this.state.msg}</span></Col>
                </Row>
            </>
        )
    }
}

/**
 * 第二步
 * 修改手机
 */
class PhoneS2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            msg1: '*',
            msg2: '',
            loading: false
        }
    }

    changPhone = (e) => {
        this.setState({
            loading: false,
            msg1: '*',
            msg2: '',
            phone: e.target.value.replace(' ', '')
        });
    }

    updatePhone() {
        this.setState({ loading: true });
        if (!CNF.regex.phone.test(this.state.phone)) {
            this.setState({
                msg1: '手机号码格式错误！'
            });
            return;
        }
        if (this.state.phone === this.props.phone) {
            this.setState({
                msg1: '请输入新手机号码！'
            });
            return;
        }
        const _this = this;
        $.ajax({
            url: CNF.api + 'users/securityinfo',
            type: 'PATCH',
            headers: AddRequestHeaders(),
            dataType: 'JSON',
            data: JSON.stringify({
                'type': 'phone',
                'verify_fingerprint': this.props.verifyFingerprint,
                'phone': this.state.phone
            }), success: function (data) {
                _this.setState({ msg2: data.msg });
                if (data.res === 0) {
                    _this.props.changeStatus(3);
                } else {
                    _this.setState({ loading: false });
                }
            }
        })
    }

    render() {
        return (
            <>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>修改手机 <span style={{ color: themeColor }}>{this.props.phone}</span>, 请完成修改。</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.phone}
                            onChange={this.changPhone}
                            placeholder='请输入新手机号码'
                            style={{ borderRadius: '0' }}
                        />
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px', lineHeight: '30px', color: 'red' }}>{this.state.msg1}</Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.updatePhone();
                            }}>马上修改</Button>
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px', lineHeight: '30px', color: 'red' }}>{this.state.msg2}</Col>
                </Row>
            </>
        )
    }
}

/**
 * 第二步
 * 修改邮箱
 */
class EmailS2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            msg1: '*',
            msg2: '',
            loading: false
        }
    }

    changEmail = (e) => {
        this.setState({
            loading: false,
            msg1: '*',
            msg2: '',
            email: e.target.value.replace(' ', '')
        });
    }

    updateEmail() {
        this.setState({ loading: true });
        if (!CNF.regex.email.test(this.state.email)) {
            this.setState({
                msg1: '邮箱格式错误！'
            });
            return;
        }
        if (this.state.email === this.props.email) {
            this.setState({
                msg1: '请输入新邮箱！！'
            });
            return;
        }
        const _this = this;
        $.ajax({
            url: CNF.api + 'users/securityinfo',
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'type': 'email',
                'verify_fingerprint': this.props.verifyFingerprint,
                'email': this.state.email
            }), success: function (data) {
                _this.setState({ msg2: data.msg });
                if (data.res === 0) {
                    _this.props.changeStatus(3);
                } else {
                    _this.setState({ loading: false });
                }
            }
        })
    }

    render() {
        return (
            <>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>修改邮箱 <span style={{ color: themeColor }}>{this.props.email}</span>, 请完成修改。</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={4} offset={5}>
                        <Input
                            value={this.state.email}
                            onChange={this.changEmail}
                            placeholder='请输入新邮箱地址'
                            style={{ borderRadius: '0' }}
                        />
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px', lineHeight: '30px', color: 'red' }}>{this.state.msg1}</Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ borderRadius: 0, border: 0 }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.updateEmail();
                            }}>马上修改</Button>
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px', lineHeight: '30px', color: 'red' }}>{this.state.msg2}</Col>
                </Row>
            </>
        )
    }
}

/**
 * 第三步
 * 完成修改
 */
const UpdateS3 = (props) => {
    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <Col span={5} offset={5}>
                    <label>账户 <span style={{ color: themeColor }}>{props.username}</span> 修改 <Tag color={themeColor}>{props.title}</Tag>已完成, 是否？</label>
                </Col>
                <Col span={2}>
                    <Button
                        block={true}
                        type='primary'
                        style={{ borderRadius: 0, border: 0 }}
                        onClick={() => {
                            DeleteCookies();
                        }}>重新登录</Button>
                </Col>
            </Row>
        </>
    )
}

/**
 * 步骤
 * 身份认证
 * 可以通过密码、电话和邮件进行身份认证
 */
const Step = (props) => {
    const [s, SetS] = useState(0);


    useEffect(() => {
        SetS(props.s);
    }, [props.s]);

    // 第一步
    const renderUpdateS1 = () => {
        switch (props.method) {
            case 'password':
                return renderPasswordS1();
            case 'phone':
                return renderPhoneS1();
            case 'email':
                return renderEmailS1();
            default:
                return null;
        }
    }

    const renderPasswordS1 = () => {
        return (
            <PasswordS1
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                changeVerifyFingerprint={props.changeVerifyFingerprint}
            />
        );
    }

    const renderPhoneS1 = () => {
        return (
            <PhoneS1
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                phone={props.securityInfo.phone}
                changeVerifyFingerprint={props.changeVerifyFingerprint}
            />
        );
    }

    const renderEmailS1 = () => {
        return (
            <EmailS1
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                email={props.securityInfo.email}
                changeVerifyFingerprint={props.changeVerifyFingerprint}
            />
        );
    }

    // 第二步
    const renderUpdateS2 = (verifyFingerprint) => {
        switch (props.m) {
            case 'password':
                return renderPasswordS2(verifyFingerprint);
            case 'phone':
                return renderPhoneS2(verifyFingerprint);
            case 'email':
                return renderEmailS2(verifyFingerprint);
            default:
                return null;
        }
    }

    const renderPasswordS2 = (verifyFingerprint) => {
        return (
            <PasswordS2
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                verifyFingerprint={verifyFingerprint}
            />
        );
    }

    const renderPhoneS2 = (verifyFingerprint) => {
        return (
            <PhoneS2
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                phone={props.securityInfo.phone}
                verifyFingerprint={verifyFingerprint}
            />
        );
    }

    const renderEmailS2 = (verifyFingerprint) => {
        return (
            <EmailS2
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                email={props.securityInfo.email}
                verifyFingerprint={verifyFingerprint}
            />
        );
    }

    const renderUpdateS3 = () => {
        return (
            <UpdateS3
                uid={props.uid}
                username={props.username}
                changeStatus={props.changeStatus}
                title={props.title}
            />
        );
    }

    if (s > 0) {
        switch (s) {
            case 1:
                return renderUpdateS1();
            case 2:
                return renderUpdateS2(props.verifyFingerprint);
            case 3:
                return renderUpdateS3();
            default:
                return null;
        }

    } else {
        return null;
    }

}

/**
 * 身份认证方式
 */
const Method = (props) => {
    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <Col span={14} offset={5}>
                    <p style={{ fontSize: '15px', fontWeight: 'bold' }}>为确保是您本人在操作, 请您选择验证方式完成身份认证：</p>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={12} offset={5}>
                    <label style={{ fontSize: '20px' }}>通过 密码验证身份</label>
                    <p>如果您还记得账户登录密码, 可选择此方式。</p>
                </Col>
                <Col span={2} style={{ textAlign: 'right' }}>
                    <Button
                        block={true}
                        type='primary'
                        variant='solid'
                        style={{ borderRadius: 0, border: 0, marginTop: '25px' }}
                        onClick={() => {
                            props.changeMethod('password');
                        }}>马上验证</Button>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={12} offset={5}>
                    <label style={{ fontSize: '20px' }}>通过 手机验证身份</label>
                    <p>如果您的手机还在正常使用, 可选择此方式。</p>
                </Col>
                <Col span={2} style={{ textAlign: 'right' }}>
                    <Button
                        block={true}
                        type='primary'
                        variant='solid'
                        style={{ borderRadius: 0, border: 0, marginTop: '25px' }}
                        onClick={() => {
                            props.changeMethod('phone');
                        }}>马上验证</Button>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={12} offset={5}>
                    <label style={{ fontSize: '20px' }}>通过 邮箱验证身份</label>
                    <p>如果您的邮箱还在正常使用, 可选择此方式。</p>
                </Col>
                <Col span={2} style={{ textAlign: 'right' }}>
                    <Button
                        block={true}
                        type='primary'
                        variant='solid'
                        style={{ borderRadius: 0, border: 0, marginTop: '25px' }}
                        onClick={() => {
                            props.changeMethod('email');
                        }}>马上验证</Button>
                </Col>
            </Row>
        </>
    );
}

export default class SecurityUpdateEntity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            securityInfo: {},
            s: 1,
            s1: 'process',
            s2: 'wait',
            s3: 'wait',
            method: '',
            verifyFingerprint: ''
        }
    }

    /**
     * 获取用户安全信息
     */
    getSecurityinfo = () => {
        const _this = this;
        $.ajax({
            url: `${CNF.api}users/securityinfo`,
            headers: AddRequestHeaders(),
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    _this.setState({
                        securityInfo: data.dat
                    });
                }
            }
        });
    }

    /**
     * 认证指纹
     * @param {*} value 
     */
    changeVerifyFingerprint = (value) => {
        this.setState({ verifyFingerprint: value });
    }

    /**
     * 安全信息修改步骤, 总共3部
     * 1：身份确认
     * 2：执行修改
     * 3：修改完成
     * @param {*} s 
     */
    changeStatus = (s) => {
        var s1 = 'process';
        var s2 = 'wait';
        var s3 = 'wait';
        switch (s) {
            case 2:
                s1 = 'finish';
                s2 = 'process';
                s3 = 'wait';
                break;
            case 3:
                s1 = 'finish';
                s2 = 'finish';
                s3 = 'process';
                break;
            default:
                break;
        }
        this.setState({
            s: s,
            s1: s1,
            s2: s2,
            s3: s3
        });
    }

    // 验证方式
    changeMethod = (m) => { this.setState({ method: m }); }

    componentDidMount() {
        this.getSecurityinfo();
    }

    render() {
        return (
            <>
                <Row>
                    <Col span={14} offset={5} style={{ marginTop: '40px' }}>
                        <Steps
                            items={[
                                {
                                    title: '身份认证',
                                    status: this.state.s1,
                                    icon: <SolutionOutlined />
                                },
                                {
                                    title: '修改' + this.props.title,
                                    status: this.state.s2,
                                    icon: <CheckOutlined />
                                },
                                {
                                    title: '修改完成',
                                    status: this.state.s3,
                                    icon: <EditOutlined />
                                }
                            ]}
                        />
                    </Col>
                </Row>
                {
                    this.state.method === '' ? (<Method changeMethod={this.changeMethod} />) : (<Step
                        uid={this.props.uid}
                        username={this.props.username}
                        m={this.props.m}
                        s={this.state.s}
                        title={this.props.title}
                        securityInfo={this.state.securityInfo}
                        method={this.state.method}
                        verifyFingerprint={this.state.verifyFingerprint}
                        changeVerifyFingerprint={this.changeVerifyFingerprint}
                        changeStatus={this.changeStatus} />)
                }
            </>
        );
    }
}